<template>
  <div>

    <Card>
      <Row :gutter="24">
          <Col span="3">
              <Input v-model="params.name" @on-change="getConsumablesWorksheet">
                  <span slot="prepend">申请人</span>
              </Input>
          </Col>
          <Col span="3">
            <Input v-model="params.department" @on-change="getConsumablesWorksheet">
                <span slot="prepend">部门</span>
            </Input>
          </Col>
          <Col span="3">
            <Input v-model="params.thing" @on-change="getConsumablesWorksheet">
                <span slot="prepend">物资</span>
            </Input>
          </Col>
          <Col span="3">
            <Input v-model="params.group" @on-change="getConsumablesWorksheet">
                <span slot="prepend">组</span>
            </Input>
          </Col>
          <Col span="3">
            <Input v-model="params.remark" @on-change="getConsumablesWorksheet">
                <span slot="prepend">备注</span>
            </Input>
          </Col>
          <Col span="3">
              <Button type="text" icon="md-refresh-circle" @click="getConsumablesWorksheet"></Button>
          </Col>
      </Row>
    </Card>

    <Table highlight-row ref="currentRowTable" :columns="workflowColumns" :data="assetList"></Table>
    <Page :total="count" :current="params.page" show-sizer show-total :page-size="params.size" @on-change="currentHandle" @on-page-size-change="pageSizeHandle"></Page>

  </div>
</template>

<script>
import { getConsumablesWorksheet, deleteConsumablesWorksheet } from '@/api/logistics/worksheet'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
  name: 'ConsumablesWorksheet',
  components: { },
  data () {
    return {
      workflowColumns: [
        {
          width: 60,
          align: 'center',
          key: 'id',
          ellipsis: true,
          tooltip: true
        },

        {
          title: '姓名',
          key: 'name',
          align: 'center',
          minWidth: 180,
          ellipsis: true,
          tooltip: true
        },

        {
          title: '邮箱',
          key: 'mail',
          align: 'center',
          minWidth: 180,
          ellipsis: true,
          tooltip: true
        },

        {
          title: '部门',
          key: 'department',
          align: 'center',
          minWidth: 180,
          ellipsis: true,
          tooltip: true
        },

        {
          title: '申请时间',
          key: 'created_at',
          minWidth: 180,
          align: 'center',
          ellipsis: true,
          tooltip: true
        },

        {
          title: '所属组',
          key: 'group',
          minWidth: 180,
          align: 'center',
          ellipsis: true,
          tooltip: true
        },

        {
          title: '领取物资',
          key: 'thing',
          minWidth: 100,
          align: 'center',
          ellipsis: true,
          tooltip: true,
          render: (h, params) => {
            return h('div', [
              h('Tag', {
                props: {
                  color: params.row.count > 1 ? '#7232dd' : params.row.count > 10 ? 'red' : 'green'
                }
              }, params.row.thing)
            ])
          }
        },

        {
          title: '数量',
          key: 'count',
          minWidth: 100,
          align: 'center',
          ellipsis: true,
          tooltip: true,
          render: (h, params) => {
            return h('div', [
              h('Tag', {
                props: {
                  color: params.row.count > 1 ? '#7232dd' : params.row.count > 10 ? 'red' : 'green'
                }
              }, params.row.count)
            ])
          }
        },

        {
          title: '备注',
          key: 'remark',
          minWidth: 180
        },

        {
          title: '操作',
          align: 'center',
          fixed: 'right',
          minWidth: 180,
          render: (h, params) => {
            let groups = []
            this.$store.state.user.groups.forEach(_g => {
              groups.push(_g.name)
            })
            return h('div', [
              h('Poptip', {
                props: {
                  confirm: true,
                  transfer: true,
                  placement: 'bottom',
                  title: '你确定要删除吗?'
                },
                // style: {
                //   display: (groups.indexOf('软件审批') !== -1 || this.$store.state.user.superuser) ? 'inline-block' : 'none'
                // },
                on: {
                  'on-ok': () => {
                    deleteConsumablesWorksheet({ id: params.row.id }).then(_ => {
                      this.getConsumablesWorksheet()
                    })
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  }
                }, '删除')
              ])
            ])
          }
        }
      ],
      params: { page: 1, size: 10 },
      assetList: [],
      count: 0
    }
  },

  mounted () {
    this.getConsumablesWorksheet()
  },

  methods: {

    getConsumablesWorksheet () {
      getConsumablesWorksheet(this.params).then(rsp => {
        const { results, count } = rsp.data
        this.assetList = results
        this.count = count
      })
    },

    currentHandle (page) {
      this.params.page = page
      this.getConsumablesWorksheet()
    },

    pageSizeHandle (size) {
      this.params.size = size
      this.getConsumablesWorksheet()
    },

    filterMethod (data, query) {
      return data.label.indexOf(query) > -1
    },

    renderFormat (item) {
      return `<span title="${item.label + ' （' + item.price + ' ' + item.currency}")>${item.label + ' (' + item.price + ' ' + item.currency + ')'}</span>`
    }

  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
  .myinput .ivu-input[disabled], fieldset[disabled] .ivu-input :nth-last-child(1){
    color: red !important;
}
</style>
